<script>
import { EventBus } from '@/event-bus';
import { fabric } from 'fabric';
import ImageBoxTool from './ImageBoxTool';
import { REMOVEBG_API } from '../../config';

const SERVER_DOWN_ERROR = 'Please try again. If this issue persists contact Customer Support <br><a href="mailto:support@helloseer.com">(support@helloseer.com)</a>.';
const TIMEOUT_ERROR = 'Oops! We were unable to remove this background. Please check your internet connection and try again.';
const UNPROCESSABLE_ERROR = 'Oops! Please select an alternate image and try again.';

export default {
  name: 'RemoveBackgroundImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'remove-background',
      title: 'Remove Background',
      showLocal: true,
      hotkey: 'ctrl+b',
      bg_disabled: [],
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  mounted() {
    this.activate();
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    activate() {
      if (this.canvas && this.canvas.getActiveObject()) {
        this.showLocal = (this.canvas.getActiveObject().get('type') === 'image');
      } else {
        this.showLocal = false;
      }
    },
    action() {
      const object = this.canvas.getActiveObject();
      if (object === undefined) {
        return;
      }
      if (this.bg_disabled.includes(object.cacheKey)) {
        return;
      }

      if (object.get('type') === 'image') {
        const url = REMOVEBG_API;
        this.$emit('loading');
        this.bg_disabled.push(object.cacheKey);
        this.$http.post(
          url,
          { url: object.getSrc() },
        ).then((nobgResponse) => {
          // Use S3 source url
          const s3url = nobgResponse.data.clean;
          const {
            left, top, scaleX, scaleY, clipPath, meta, angle,
          } = object;
          const img = new Image();
          img.onload = () => {
            // Create new fabric image
            // eslint-disable-next-line
            new fabric.Image.fromURL(img.src, (image) => {
              // Center and preserve clipping
              image.set({
                left,
                top,
                angle,
                originX: object.originX,
                originY: object.originY,
                scaleX,
                scaleY,
                clipPath,
                meta,
              });
              image.setControlsVisibility({
                mt: false, // middle top disable
                mb: false, // midle bottom
                ml: false, // middle left
                mr: false, // I think you get it
              });

              // replace previous object
              this.canvas.remove(object);
              this.canvas.add(image);
              this.canvas.renderAll();
              this.$emit('finished');

              const elementLock = this.bg_disabled.indexOf(object.cacheKey);
              if (elementLock > 0) {
                this.bg_disabled.splice(elementLock, 1);
              }
            }, { crossOrigin: 'anonymous' });
          };
          img.src = s3url;
          this.$nextTick().then(() => {
            this.canvas.renderAll();
            this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
          });
        }).catch((e) => {
          let errorMessage = '';
          // BG remove API error
          console.error(e);
          if (e.response) {
          // Reference: https://www.remove.bg/api
          // Request was made and responded
            const { status } = e.response;
            if (status === 400) {
            // Unprocessable
              errorMessage = UNPROCESSABLE_ERROR;
            } else if (status < 500) {
            // Account / credits related error
              errorMessage = SERVER_DOWN_ERROR;
            } else {
            // Server error
              errorMessage = SERVER_DOWN_ERROR;
            }
          } else if (e.request) {
          // Request was made but not responded
            errorMessage = TIMEOUT_ERROR;
          } else {
          // Error before request (likely programming error)
            errorMessage = SERVER_DOWN_ERROR;
          }
          EventBus.$emit('toast-error', errorMessage);
          this.$emit('finished');
          const elementLock = this.bg_disabled.indexOf(object.cacheKey);
          if (elementLock > 0) {
            this.bg_disabled.splice(elementLock, 1);
          }
        });
      }
    },
  },
};
</script>
